/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FormattedMessage} from 'react-intl';
import {RouteButtonLink} from 'components/link';
import {
  NewButton,
  EditButton,
  IconActionButton,
  InlineActionButton,
} from 'components/form';
import AddIcon from 'icons/AddIcon';
import './PageHeading.css';
import SettingsIcon from 'icons/SettingsIcon';
import {ButtonGroup, ToggleButton} from 'react-bootstrap';
import FieldLabel from 'components/form/field/FieldLabel';

const PageHeading = ({
  text,
  icon: Icon,
  newText,
  newRoute,
  newRouteParams,
  newOnClick, // this should be renamed in the future because it's used for new/edit/settings onClick actions
  newDisabled,
  approveButton = false,
  approveOnClick = null,
  denyOnClick = null,
  approveMessage = null,
  denyMessage = null,
  canView = false,
  editButton = false,
  submitButton = false,
  submitText = null,
  submitOnClick = null,
  submitDisabled = false,
  specialRequest = false,
  settingsIcon = false,
  showCustomToggle = false,
  customToggleChecked = false,
  customToggleLabel = null,
}) => {
  return (
    <div className="d-md-flex align-items-center mb-3">
      <h3 className="PageHeading mb-2 mb-md-0 mr-auto">
        {Icon && <Icon />}
        <FormattedMessage {...text} />
      </h3>
      {newRoute ? (
        <RouteButtonLink
          text={newText}
          route={newRoute}
          params={newRouteParams}
          icon={AddIcon}
          onClick={newOnClick}
        />
      ) : approveButton && !settingsIcon && !showCustomToggle && canView ? (
        <div className="d-flex align-items-center">
          <InlineActionButton
            message={denyMessage}
            variant="secondary"
            onClick={denyOnClick}
            compact={true}
            className="border-0"
          />
          <div className="ml-2">
            <InlineActionButton
              message={approveMessage}
              variant="primary"
              onClick={approveOnClick}
              compact={true}
              className="border-0"
            />
          </div>
        </div>
      ) : (
        newOnClick &&
        (submitButton && !settingsIcon && !showCustomToggle ? (
          <>
            <div className="d-flex align-items-center">
              <NewButton
                text={newText}
                isSpecialRequest={specialRequest}
                onClick={newOnClick}
                disabled={newDisabled}
              />
              <div className="ml-2">
                <EditButton
                  text={submitText}
                  onClick={submitOnClick}
                  isSpecialRequest={specialRequest}
                  disabled={submitDisabled}
                />
              </div>
            </div>
          </>
        ) : !editButton && !settingsIcon && !showCustomToggle ? (
          <NewButton
            text={newText}
            onClick={newOnClick}
            disabled={newDisabled}
          />
        ) : settingsIcon && !editButton && !showCustomToggle ? (
          <IconActionButton
            icon={SettingsIcon}
            variant="outline-secondary"
            onClick={newOnClick}
            compact={true}
            className="border-0"
          />
        ) : showCustomToggle && !editButton ? (
          <>
            <FieldLabel
              id="custom-toggle-label"
              label={customToggleLabel}
              required={false}
              className="mr-2 mb-3"
            />
            <ButtonGroup className="mb-2">
              <ToggleButton
                id={`radio-1}`}
                type="radio"
                size="sm"
                variant="outline-success"
                name="customToggle"
                checked={!customToggleChecked}
                onChange={newOnClick}
              >
                Yes
              </ToggleButton>
              <ToggleButton
                id={`radio-0}`}
                type="radio"
                size="sm"
                variant="outline-danger"
                name="customToggle"
                checked={customToggleChecked}
                onChange={newOnClick}
              >
                No
              </ToggleButton>
            </ButtonGroup>
          </>
        ) : (
          <EditButton
            text={newText}
            onClick={newOnClick}
            disabled={newDisabled}
          />
        ))
      )}
    </div>
  );
};

export default PageHeading;
